<div class="fiscal-parameters" *ngIf="branches.length">
  <h3>PARÂMETROS FISCAIS</h3>
  <p>Cada filial cadastrada recebe um parâmetro fiscal.</p>

  <article class="fiscal-parameter" *ngFor="let branch of branches">
    <header>
      <strong>{{ branch.branchTitle }}</strong>
      <span *ngIf="branch.branchIsMain">MATRIZ</span>
    </header>
    <div class="fiscal-parameter-grid">
      <mat-form-field appearance="outline">
        <mat-label>REGIME</mat-label>
        <mat-select
          [disabled]="readonly"
          [value]="branch.fiscalParameter.regime"
          (selectionChange)="update(branch.localKey, { regime: $event.value })">
          <mat-option *ngFor="let option of regimes" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>ATIVIDADE</mat-label>
        <input
          matInput
          [disabled]="readonly"
          [value]="branch.fiscalParameter.mainActivity"
          (change)="update(branch.localKey, { mainActivity: $any($event.target).value })" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>AMBIENTE FISCAL</mat-label>
        <mat-select
          [disabled]="readonly"
          [value]="branch.fiscalParameter.fiscalEnvironment"
          (selectionChange)="update(branch.localKey, { fiscalEnvironment: $event.value })">
          <mat-option *ngFor="let option of environments" [value]="option">{{ option }}</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="isProduction(branch)">
        <mat-form-field appearance="outline">
          <mat-label>CSC</mat-label>
          <input
            matInput
            [disabled]="readonly"
            [value]="branch.fiscalParameter.csc"
            (change)="update(branch.localKey, { csc: $any($event.target).value })" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>ID CSC</mat-label>
          <input
            matInput
            [disabled]="readonly"
            [value]="branch.fiscalParameter.cscId"
            (change)="update(branch.localKey, { cscId: $any($event.target).value })" />
        </mat-form-field>
      </ng-container>
    </div>
  </article>
</div>
